/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

import {Component, effect, forwardRef, input, signal} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {
  AtleastOneDigit_Regex,
  AtleastOneLowerCase_Regex,
  AtleastOneSpecialChar_Regex,
  AtleastOneUpperCase_Regex,
  BetweenRangeChars_Regex,
  OneLower_OneUpper_OneDigit_OneSpecial_BetweenRangeChar_Regex,
} from '@app/shared/constants';
import {TranslateModule} from '@ngx-translate/core';
import {DividerModule} from 'primeng/divider';
import {PasswordModule} from 'primeng/password';
import {IconComponent} from '../icon/icon.component';

enum ECondition {
  Lowercase,
  Uppercase,
  Numeric,
  Special,
  CharacterLengthRange,
}

@Component({
  selector: 'app-custom-password',
  imports: [PasswordModule, DividerModule, IconComponent, TranslateModule, FormsModule],
  templateUrl: './custom-password.component.html',
  styleUrls: ['./custom-password.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomPasswordComponent),
      multi: true,
    },
  ],
})
export class CustomPasswordComponent implements ControlValueAccessor {
  readonly feedback = input(true);
  readonly disabled = input(false);
  readonly _disabled = signal(false);
  readonly toggleMask = input(true);
  readonly placeHolder = input('Password');
  readonly position = input<'bottomright' | 'bottomleft'>('bottomleft');
  readonly floatLabel = input('');

  password!: string;
  ECondition = ECondition;
  passwordComplexity = OneLower_OneUpper_OneDigit_OneSpecial_BetweenRangeChar_Regex;

  constructor() {
    effect(() => {
      this._disabled.set(this.disabled());
    });
  }

  writeValue(value: string): void {
    this.password = value;
  }

  onChange = (value: string | null) => {};

  onTouched = () => {};

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._disabled.set(isDisabled);
  }

  hasAtLeastOne(condition: ECondition) {
    const value = this.password || '';
    switch (condition) {
      case ECondition.Lowercase:
        return AtleastOneLowerCase_Regex.test(value);

      case ECondition.Uppercase:
        return AtleastOneUpperCase_Regex.test(value);

      case ECondition.Numeric:
        return AtleastOneDigit_Regex.test(value);

      case ECondition.Special:
        return AtleastOneSpecialChar_Regex.test(value);

      case ECondition.CharacterLengthRange:
        return BetweenRangeChars_Regex.test(value);
    }
  }
}
